import {tabClasses, type Components, type CSSObject, type Theme} from '@mui/material';

export const MuiTab = (theme: Theme): Components['MuiTab'] => ({
  styleOverrides: {
    root: {
      ...(theme.typography.BodyMedium as CSSObject),
      whiteSpace: 'nowrap',
      color: theme.palette.text3,
      [`&.${tabClasses.selected}`]: {
        color: theme.palette.primaryBrandText,
      },
    },
  },
});

export const MuiTabs = (theme: Theme): Components['MuiTabs'] => ({
  styleOverrides: {
    indicator: {
      height: 3,
      borderTopLeftRadius: 1000,
      borderTopRightRadius: 1000,
      backgroundColor: theme.palette.primaryBrandBg,
    },
    scrollableX: {
      '& .MuiTab-root': {
        minWidth: 'auto',
        padding: theme.spacing(1.5),
      },
    },
  },
});
